import React from "react";
import ProductDetailSleekComponent from "../components/product/detailSleek";

const ProductDetailSleek = () => {
  return (
    <>
      <ProductDetailSleekComponent />
    </>
  );
};

export default ProductDetailSleek;
